// tslint:disable:max-line-length

import React from 'react';

export const UtilityDocumentation = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M3.5,0v9h12V1c0-0.6-0.4-1-1-1h-1v6l-2-2l-2,2V0H3.5L3.5,0z M2.5,0.2c-1.2,0.4-2,1.5-2,2.8v7.4c0.5-0.6,1.2-1,2-1.2V0.2 L2.5,0.2z M3.5,10c-1.7,0-3,1.3-3,3s1.3,3,3,3l0,0h12v-2h-12c-0.6,0-1-0.4-1-1s0.4-1,1-1h12v-2H3.5z" />
    </svg>
  );
};
